<template>
  <div>
    <page-header></page-header>
    <div id="page">

      <page-main></page-main>
      <page-info></page-info>
      <page-footer></page-footer>
    </div>
    <div class="loading" id="loading"><div><img src="@/assets/images/public/loading.gif" alt=""></div></div>
  </div>

</template>

<script>
import pageHeader from './pageHeader/index'
import pageMain from './pageMain/index'
import pageInfo from './pageInfo/index'
import pageFooter from './pageFooter/index'


export default {
  name: 'pageLayout',
  components: {pageHeader,pageMain,pageInfo,pageFooter},
  data () {
    return {

    }
  },
}
</script>

<style lang="stylus">
  #page
    position relative;min-height 100vh;
</style>
